export const formatNumber = (value?: number) =>
  value?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

export const formatCurrency = (value?: number) =>
  value || value === 0
    ? new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: "GBP",
      }).format(value)
    : "-";

export const isNumeric = (n: any) => {
    return !isNaN(parseFloat(n)) && isFinite(n);
    };
      
      